module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grouped-invoice"
  }, [(!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-lg-offset-3 col-sm-12"
  }, [_c('div', {
    staticClass: "pull-right hidden-print"
  }, [_c('print'), _vm._v(" \n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "lead text-center"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Bookings")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                        " + _vm._s(_vm.numberOfInvoices) + " bookings\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("VAT")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.totalAmount * 0.20, 2))) + ",- DKK\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Subtotal")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.totalAmount * 0.80, 2))) + ",- DKK\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.totalAmount, 2))) + ",- DKK\n                                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-lg-offset-3 col-sm-12"
  }, _vm._l((_vm.reservations), function(reservation) {
    return _c('div', {
      key: reservation.id
    }, [_c('invoice', {
      attrs: {
        "id": reservation.id
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)
  }), 0)])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d78c3a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reservations/GroupedInvoice.vue
// module id = 408
// module chunks = 1